import { Button, Dropdown } from 'react-bootstrap'
import { numberFormatCurrency } from '../../../utils/helpers'
import { formatToLocalTime } from '../../../utils/dates'
import { getAddressCompany } from '../../../utils/company'
import useAppContext from '../../app'
import './DocumentHeader.scss'

const DocumentHeader = ({
  documentType,
  documentNumber,
  purchaseOrder,
  dateCreated,
  createdBy,
  total,
  currency = 'usd',
  client,
  company,
  companyLogo,
  buttons,
  statusBadge,
  detailRows,
  onBack,
  showTotal = true,
}) => {
  const { store: { isLog } } = useAppContext()

  const clientName = client?.name || ''
  const clientPhone = client?.phone || ''
  const clientEmail = client?.email || ''
  const clientAddress = client
    ? [client.street, client.city, client.state, client.zip].filter(s => s && s.trim()).join(', ')
    : ''

  const companyName = company?.name || ''
  const companyPhone = company?.phone || ''
  const companyEmail = company?.email || ''
  const companyAddress = company?.shopAddress ? getAddressCompany(company.shopAddress) : ''

  return (
    <div className="document-header-wrapper">
      {isLog && onBack && (
        <button type="button" className="document-header-back" onClick={onBack} aria-label="Go back">
          <i className="fa fa-chevron-left" />
        </button>
      )}
      <div className="document-header-card">
        <div className="document-header-top">
          <div className="document-header-title-row">
            <div className="document-header-title-group">
              <h4 className="document-header-title">
                {documentType} #{documentNumber}
              </h4>
              {purchaseOrder && (
                <span className="document-header-po">PO: {purchaseOrder}</span>
              )}
            </div>
            {statusBadge}
          </div>
          <div className="document-header-buttons">
            {buttons}
          </div>
        </div>
        <div className="document-header-content">
          <div className="document-header-left">
            <div className="document-header-details">
              {dateCreated && (
                <span className="document-detail-item">
                  Date Created: {formatToLocalTime(dateCreated)}
                </span>
              )}
              {createdBy && (
                <span className="document-detail-item">
                  Created by: {createdBy}
                </span>
              )}
              {detailRows}
            </div>
            {clientName && (
              <>
                <div className="document-header-divider" />
                <div className="document-header-client">
                  <span className="document-header-client-name">{clientName}</span>
                  {clientAddress && <span>{clientAddress}</span>}
                  {clientPhone && <span>{clientPhone}</span>}
                  {clientEmail && <span>{clientEmail}</span>}
                </div>
              </>
            )}
            {companyName && (
              <>
                <div className="document-header-divider" />
                {companyLogo && (
                  <img
                    className="document-header-company-logo"
                    src={companyLogo}
                    alt={companyName}
                  />
                )}
                <div className="document-header-company">
                  <span className="document-header-company-name">{companyName}</span>
                  {companyAddress && <span>{companyAddress}</span>}
                  {companyPhone && <span>{companyPhone}</span>}
                  {companyEmail && <span>{companyEmail}</span>}
                </div>
              </>
            )}
          </div>
          {showTotal && (
            <div className="document-header-right">
              <span className="document-header-total-label">Total</span>
              <span className="document-header-total-value">
                {numberFormatCurrency(currency, total)}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export const HeaderButton = ({ children, variant = 'outline', onClick }) => {
  const isPrimary = variant === 'primary'
  return (
    <button
      type="button"
      className={`document-header-btn ${isPrimary ? 'document-header-btn--primary' : 'document-header-btn--outline'}`}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export const PDFDropdownButton = ({ onViewPdf, onViewWithoutDiscount }) => {
  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="primary"
        className="document-header-btn document-header-btn--primary"
        style={{ border: 'none' }}
      >
        VIEW PDF
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onViewPdf(false)}>
          Invoice with Discount
        </Dropdown.Item>
        <Dropdown.Item onClick={() => onViewPdf(true)}>
          Invoice without Discount
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default DocumentHeader
